import { style } from '@vtex/admin-ui'

import { buildProductImageContainerVariants } from '@/components/products-listing/product-image.styles'

export const skuRowLinkWrapper = style({
  display: 'contents',
})

export const skuRow = style({
  svg: { marginRight: '$space-0' },
  display: 'contents',
  '.sku-quick-action': {
    display: 'none',
    '&:disabled': {
      cursor: 'not-allowed',
    },
    '&[aria-disabled="true"]': {
      cursor: 'not-allowed',
    },
  },
  '.sku-title': {
    width: 'revert',
  },
  ':hover': {
    '.sku-quick-action': {
      display: 'revert',
    },
    '.sku-title': {
      width: '20rem',
    },
  },
})

export const skuCell = style({
  display: 'flex',
  gridColumn: '2 / 4',
  gap: '$space-3',
  height: '42px !important',
})

export const skuWrapper = style({
  display: 'flex',
  alignItems: 'center !important',
  gap: '$space-3',
})

export const skuName = style({
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
})

export const skuImageContainer = buildProductImageContainerVariants({
  imageSize: 2,
})
